import React, { useState } from 'react';
import { withInjectedProps } from '../InjectedPropsContext';
import FormattedText from './FormattedText';

interface IJoinedFormattedTextProps {
  names: string[];
  separator?: string;
  blankReplacement?: string;
  valueBlankReplacement?: string;
}

// Outputs a string that joins the values for the names with the given separator
let JoinedFormattedText: React.FC<IJoinedFormattedTextProps> = ({
  names,
  separator = ', ',
  blankReplacement,
  valueBlankReplacement,
}) => {
  const [hasValues, setHasValues] = useState(Array(names.length).fill(false));

  const setHasValueForIndex = ({ index, hasValue }: { index: number; hasValue: boolean }) => {
    if (hasValues[index] !== hasValue) setHasValues(Object.assign([...hasValues], { [index]: hasValue }));
  };

  return (
    <>
      {[
        !hasValues.some((hv) => hv) && (!valueBlankReplacement || names.length === 0) && blankReplacement,
        ...names.map((n, i) => (
          <React.Fragment key={i}>
            {((valueBlankReplacement && i !== 0) || (hasValues.slice(0, i).some((hv) => hv) && hasValues[i])) &&
              separator}
            <FormattedText
              name={n}
              hasValueCallback={(hasValue) => setHasValueForIndex({ index: i, hasValue })}
              blankReplacement={valueBlankReplacement}
            />
          </React.Fragment>
        )),
      ]}
    </>
  );
};

JoinedFormattedText = withInjectedProps(JoinedFormattedText);

export { JoinedFormattedText };
export default JoinedFormattedText;
